import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { areAllCreativesSelected } from 'selectors/Selected';
import { clearLevel, selectMultiple } from "reducers/Selected";
import SelectAllCell from "./SelectAllCell";


export default function SelectAllCreativesCell() {
	let dispatch = useDispatch();

	let { creatives, isAllSelected } = useSelector(state => ({
		creatives: state.creatives.items,
		isAllSelected: areAllCreativesSelected(state),
	}));

	function toggleSelectAll() {
		if (isAllSelected) {
			dispatch(clearLevel('creatives'));
		} else {
			dispatch(selectMultiple(creatives.map(creative => creative.id), 'creatives', true));
		}
	}

	return (
		<SelectAllCell className="select-all-creatives" column={{ selectAll: toggleSelectAll, isAllSelected }} />
	);
}

SelectAllCreativesCell.displayName = "SelectAllCreativesCell";
